import { Plans, Product, subscriptionApi } from '@commerce-subscription-webcomponents/sdk';
import { CartDrawer } from '@commerce-product-webcomponents/ui-composite';
import { getFulfillmentType } from '@commerce-product-webcomponents/ui';
import { useEffect, useState } from 'react';
import {
  IProduct,
  productApi,
  ProductData,
  productDataTransformer,
  VariantGroup,
} from '@commerce-product-webcomponents/sdk';
import { CartConstantsEnum, CartEntryDetails, updateVariantGroupHandler } from '@commerce-cart-webcomponents/sdk';
import { StorageService } from '@nextgen-web-framework/core';
import { useExceptionToast } from '../../../common';

export type SOPVariantDrawerProps = {
  entryData: CartEntryDetails;
  planCode?: string;
  onCloseClick?: () => void;
};

const SOPVariantDrawer = ({ planCode, entryData, onCloseClick }: SOPVariantDrawerProps) => {
  const [productData, setProductData] = useState({} as IProduct);
  const [updatedVariantGroup, setUpdatedVariantGroup] = useState<VariantGroup>({});
  const triggerToast = useExceptionToast();

  const getSubscriptionData = (productDetails: ProductData) => {
    subscriptionApi
      .getPlanDetailsByPlanCodes({
        planCodes: planCode as string,
      })
      .then((res: Plans) => {
        const productOptions = res.plans?.[0]?.productOptions as Product[];

        const variantGroupData =
          productDetails.variantGroup &&
          updateVariantGroupHandler(
            productDetails.variantGroup,
            productOptions,
            entryData?.product?.basePrice?.value ?? 0,
          );

        setUpdatedVariantGroup(variantGroupData ?? {});
      })
      .catch(() => {
        triggerToast();
      });
  };

  useEffect(() => {
    productApi
      .getProductByIdOrError({
        productId: entryData.product.id,
        warehouseId: StorageService.getLocalStorage().retrieve(CartConstantsEnum.WarehouseId),
        fulfillmentType: getFulfillmentType(),
      })
      .then((productData: ProductData | Response) => {
        if (!(productData instanceof Response)) {
          setProductData(productDataTransformer(productData));
          getSubscriptionData(productData);
        }
      })
      .catch(() => {
        triggerToast();
      });
  }, []);

  return (
    <>
      {Boolean(Object.keys(productData).length && Object.keys(updatedVariantGroup).length) && (
        <CartDrawer
          link={productData.mainLink ?? ''}
          alt={productData.alt ?? ''}
          brandName={productData.brandName ?? ''}
          productName={productData.productName ?? ''}
          productPrice={productData.productPrice ?? 0}
          currency={productData.currency}
          productId={productData.productId}
          productSize={productData.productSize ?? ''}
          onClose={onCloseClick}
          cartBaseurl={''}
          entryId={entryData.entryId ?? 0}
          derivedAvailabilityStockStatus={productData.derivedAvailabilityStatus ?? ''}
          variantGroup={updatedVariantGroup}
        />
      )}
    </>
  );
};
export { SOPVariantDrawer };
